import { render, staticRenderFns } from "./SubmitDemoPage.vue?vue&type=template&id=5f868d09&scoped=true"
import script from "./SubmitDemoPage.vue?vue&type=script&lang=js"
export * from "./SubmitDemoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f868d09",
  null
  
)

export default component.exports